import { getLang } from "helpers/themeHelpers";

export const linkToBuyRentComparisonCalculator = () => {
  const locale = getLang();
  return `/${locale}/${
    locale === "ar"
      ? "حاسبة-مقارنة-تأجير-شراء-العقارات"
      : "buy-rent-comparison-calculator"
  }`;
};
